import { motion } from 'framer-motion';

interface MarqueeProps {
  items: string[];
  direction?: 'left' | 'right';
  speed?: number;
}

export default function Marquee({ items, direction = 'left', speed = 50 }: MarqueeProps) {
  const duplicatedItems = [...items, ...items, ...items];

  return (
    <div className="relative overflow-hidden py-4 bg-dark-lighter/30">
      <motion.div
        animate={{
          x: direction === 'left' ? [0, -1000] : [-1000, 0],
        }}
        transition={{
          duration: speed,
          repeat: Infinity,
          ease: 'linear',
        }}
        className="flex gap-8 whitespace-nowrap"
      >
        {duplicatedItems.map((item, index) => (
          <div
            key={index}
            className="glass-card px-6 py-3 inline-block"
          >
            <span className="text-neon-blue font-semibold">{item}</span>
          </div>
        ))}
      </motion.div>
    </div>
  );
}
